// react-router-dom components
import {Link} from "react-router-dom";

// internationalization.
import {useTranslation} from "react-i18next";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import {Breadcrumbs as MuiBreadcrumbs} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "materialDashboard/components/MDBox";
import MDTypography from "materialDashboard/components/MDTypography";


import {useMatches} from "react-router-dom";

function Breadcrumbs({light}) {
    const {t} = useTranslation(['layouts']);
    let matches = useMatches();
    let crumbs = matches.filter((match) => Boolean(match.handle?.crumb)) // get rid of any matches that don't have handle and crumb
    const crumbsLabel = crumbs.map((match) => t(`breadcrumbs.${match.handle.crumb}`));

    return <MDBox mr={{xs: 0, xl: 8}}>
        {
            crumbsLabel.length > 0 &&
            <MDTypography
                fontWeight="bold"
                textTransform="capitalize"
                variant="h6"
                color={light ? "white" : "dark"}
                noWrap
            >
                {crumbsLabel[crumbsLabel.length - 1]}
            </MDTypography>
        }
        <MuiBreadcrumbs
            sx={{
                "& .MuiBreadcrumbs-separator": {
                    color: ({palette: {white, grey}}) => (light ? white.main : grey[600]),
                },
            }}
        >
            <Link to="/">
                <MDTypography
                    variant="button"
                    fontWeight="regular"
                    textTransform="capitalize"
                    color={light ? "white" : "dark"}
                    opacity={light ? 0.8 : 0.5}
                    sx={{lineHeight: 0}}
                >
                    YetiWeb
                </MDTypography>
            </Link>
            {crumbsLabel.map((el, i) => (i !== crumbs.length - 1 ?
                <Link to={crumbs[i].pathname} key={el}>
                    <MDTypography
                        component="span"
                        variant="button"
                        fontWeight="regular"
                        textTransform="capitalize"
                        color={light ? "white" : "dark"}
                        opacity={light ? 0.8 : 0.5}
                        sx={{lineHeight: 0}}
                    >
                        {el}
                    </MDTypography>
                </Link>
                :
                <MDTypography
                    key={el}
                    variant="button"
                    fontWeight="regular"
                    textTransform="capitalize"
                    color={light ? "white" : "dark"}
                    sx={{lineHeight: 0}}
                >
                    {el}
                </MDTypography>))}
        </MuiBreadcrumbs>
    </MDBox>;
}

// Setting default values for the props of Breadcrumbs
Breadcrumbs.defaultProps = {
    light: false,
};

// Typechecking props for the Breadcrumbs
Breadcrumbs.propTypes = {
    icon: PropTypes.node.isRequired,
    light: PropTypes.bool,
};

export default Breadcrumbs;
